<template>
  <div
    class="result-card-skeleton"
    data-testid="workspace-document-card-skeleton"
  >
    <PVSkeleton
      class="result-card-skeleton__preview"
      width="6rem"
      height="6rem"
    />
    <div class="result-card-skeleton__content">
      <div class="result-card-skeleton__header">
        <PVSkeleton width="55%" height="1.25rem" />
        <PVSkeleton width="3.25rem" height="1.5rem" />
      </div>
      <div class="result-card-skeleton__meta">
        <div
          v-for="rowIndex in metaRowCount"
          :key="rowIndex"
          class="result-card-skeleton__meta-row"
        >
          <PVSkeleton width="6.5rem" height="0.875rem" />
          <PVSkeleton width="100%" height="0.875rem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import PVSkeleton from 'primevue/skeleton';

  const metaRowCount = 6;
</script>

<style scoped lang="scss">
  .result-card-skeleton {
    display: grid;
    grid-template-columns: 6rem minmax(0, 1fr);
    gap: 1rem;
    padding: 1rem 1.1rem;
    border-radius: 0.75rem;
    background: var(--p-surface-50);

    &__preview {
      align-self: center;
      border-radius: 0.75rem;
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: 0.875rem;
      min-width: 0;
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }

    &__meta {
      display: flex;
      flex-direction: column;
      gap: 0.625rem;
    }

    &__meta-row {
      display: grid;
      grid-template-columns: 6.5rem minmax(0, 1fr);
      align-items: center;
      column-gap: 0.75rem;
    }
  }
</style>
